import instance from "services";

export default DeactiveUser

async function DeactiveUser(id:string ) {
    const response = await instance.put(`/v1/backoffice/backoffice-users/deactive-user/${id}`);
    return response.data;
}
